<script>

import { useToast } from "vue-toastification";

import LoadingScreen from '@/components/General/LoadingScreen'
import Alert from '@/components/General/Alert'
	
//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

//data
import { getGalleryInfo, setDefaultPhotoToGallery } from '@/services/serviceGallery';
import { getPhotosPreviewByGallery, rotatePhoto } from '@/services/servicePhoto';

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'GalleryPreview',
	mixins: [ MixinGeneralFunct ],
	components: {
		LoadingScreen
		,Alert
	},
	props: {'galleryId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	data() {
		return {
			prefix:'',
			
			params:[],
			metaData: [],
			
			isLoading:true,
						
			optionsGalleries:[],
			selectedGallery:'',

			//form
			gallery:[],
			photos:[]
		}
	},
	
	mounted:function(){
	
	},
	
	methods: {
		// load data form
		onLoadPage:function(){

			this.isLoading=true

			getGalleryInfo({galleryId:this.galleryId}).then(response => {
				if(!response.statusText){
					this.gallery = response.data;
					this.metaData = response.metaData;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
			
			

			getPhotosPreviewByGallery({galleryId:this.galleryId}).then(response => {
				console.log(response)
				if(!response.statusText){
					this.isLoading=false
					this.photos = response.photos;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		
		},
		
		onCloseModal:function(){
			this.modalObject.hide();
		},

		//otocenie obrazku o 90
		onRotateState:function(photoId){
			this.cSession();			
			this.isLoading=true
			rotatePhoto({photoId}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasSaved'));
						this.onLoadPage();
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==2){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
				}else{
					this.isLoading=false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

		},
		
		//vyber default obrazku
		onSelectDefault:function(photoId){
			this.cSession();			
			this.isLoading=true
			setDefaultPhotoToGallery({galleryId:this.galleryId,photoId}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasSaved'));
						this.onLoadPage();
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==2){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
				}else{
					this.isLoading=false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

		}
		
	},
	
	watch: {
		galleryId() {
			this.onLoadPage();
		},
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>
		<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog modal-fullscreen">
				<LoadingScreen :isLoading="isLoading"></LoadingScreen>
			<div class="modal-content">
				<div class="modal-header">
					<h6 class="modal-title">{{ $t('msgCore.Preview') }} <span><b>{{ gallery.title }}</b> </span></h6>
				</div>
		
				<div class="modal-body">

					<div v-if="metaData.modulAccess" >

						<div class="row">
							<div class="col-12">
								<div class="row">
									<div v-for="photo in photos" :key="photo" class="col-lg-2 col-md-4 col-6 ">
										<div class="row">
											<div class="col-12 crop_gallery2">
												<a class="fancybox" data-fancybox="gallery" :href="photo.photoUrl"><img class="img-fluid" :src="photo.photoUrlThumb" :title="photo.title"></a>
											</div>
										
											<div class="col-12">
												<button type="button" :disabled="!auth.photosRotate" v-on:click="onRotateState(photo.id)" :title="$t('msgCore.btnRotate')" class="btn btn-primary btn-sm"><i class="smire-icon fas fa-sync"></i></button>
												<button v-if="!photo.isSelected" type="button" :disabled="!auth.galleriesEdit" v-on:click="onSelectDefault(photo.id)" :title="$t('msgCore.btnSelect')" class="btn btn-warning btn-sm"><i class="smire-icon fas fa-check"></i></button>
												<span v-if="photo.isSelected"><i class="fas fa-check text-success"></i></span>
											</div>

										</div>
									</div>
								</div>
							</div>
						</div>

					</div>

					<div v-else class="container-fluid">
						<div class="row">
							<div class="col-12 mt-3">
								<Alert type="warning" :label="$t('msgCore.accessDenied')" />
							</div>
						</div>
					</div>


				</div>
				
				<div class="modal-footer">
					<div class="btn-group">
						<button type="button" v-on:click="onCloseModal()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>

						
					</div>	
				</div>
						
			</div>

		</div>
		
	</div>
</div>
	
</template>


